import { useEffect } from "react";
import { scroller } from "react-scroll";

function ScrollToHashElement() {
  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      const id = hash.replace("#", "");

      scroller.scrollTo(id, {
        duration: 500,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: -70, // Same as your Link offset
      });
    }
  }, []);

  return null;
}

export default ScrollToHashElement;
